
import { withAuthRetry } from '../utils/authRetry';
import { FinalizeReviewRequest, FinalizeReviewResponse } from '../finalizereview';
import { Section } from '../schema';

export async function finalizeReview(
    caseId: string,
    reviewedSections: Section[],
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<FinalizeReviewResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/protobuf',
            'Authorization': 'Bearer ' + token
        };

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = `https://yivxudpoyjwik6yjtkmxedyj5y0iycda.lambda-url.us-west-2.on.aws/reviewservice/finalizereview`;
        if (staging) {
            url = `https://43dim7ucbfrp62ivpzpjxtnszu0foonq.lambda-url.us-west-2.on.aws/reviewservice/finalizereview-staging`;
        }

        const request: FinalizeReviewRequest = {
            caseId,
            reviewedSections
        };
        const bodyBytes = FinalizeReviewRequest.encode(request).finish();

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: bodyBytes
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): FinalizeReviewResponse => {
        if (bytes.length === 0) {
            return { success: true };
        }
        return FinalizeReviewResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
